import { AuthProvider } from '../context/auth'
import { ProductsProvider } from '../context/products'

export function AppProvider({ children }) {
  return (
    <AuthProvider>
      <ProductsProvider>{children}</ProductsProvider>
    </AuthProvider>
  )
}
